import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import _ from "lodash";
import httpClient from "./api/httpClient";
import dateFilter from "./helpers/filters/date";
import numeralFilter from "./helpers/filters/numeral";
import Avatar from "@/components/common/Avatar";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import questionTypes from "@/helpers/enums/questionTypes";
import images from "@/helpers/enums/images";
import rules from "@/helpers/rules";

Vue.prototype._ = _;
Vue.prototype.$questionTypes = questionTypes;
Vue.prototype.$images = images;
Vue.prototype.$rules = rules;

Vue.filter("normalDate", dateFilter.normalDate);
Vue.filter("longDate", dateFilter.longDate);
Vue.filter("longDateNoTz", dateFilter.longDateNoTz);
Vue.filter("time", dateFilter.time);
Vue.filter("one_decimal", numeralFilter.one_decimal);

Sentry.init({
  dsn: process.env.VUE_APP_SENTRY_URL,
  environment: process.env.NODE_ENV,
  integrations: [
    new VueIntegration({
      Vue,
      logErrors: true,
      attachProps: true
    })
  ],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
});

Vue.component("avatar", Avatar);
Vue.component("loading-spinner", LoadingSpinner);

Vue.prototype.$http = httpClient;

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
